<a
  [routerLink]="['/jobs/job/', referralReportItem.jobId, 'total-matches']"
  [queryParams]="{ category: associationLabel, offset: 0, redirect: 'true' }"
>
  <common-mojo-card>
    <div
      class="row"
      *ngIf="(isMobileViewService.isMobileView$() | async) === false; else
      mobile;"
    >
      <div class="cell col-sm-4">
        <div class="wrapper d-flex flex-column mojo-blue-hover">
          <span class="mb-2 bold"> {{ showBy === 'Job' ?
            this.referralReportItem.title :
            this.referralReportItem.referredBy }}
          </span>
          <span class="content">Function: {{ showBy === 'Job' ?
            this.referralReportItem.jobFunctionName :
            this.referralReportItem.referralFunctionName }}
          </span>
          <span class="content">
            Dept: {{ showBy === 'Job' ?
            this.referralReportItem.jobDepartmentName :
            this.referralReportItem.referralDepartmentName }}
          </span>
        </div>
      </div>

      <div class="cell col-sm-3">
        <span>{{ showBy === 'Job' ? this.referralReportItem.referredBy :
          this.referralReportItem.title }}</span>
      </div>

      <div class="cell col-sm-2">

        <div class="wrapper d-flex flex-row align-items-center">
          <a
            class="highlight-link text-truncate"
            [routerLink]="['/candidates',referralReportItem?.candidateId,
            'details']"
            [matTooltip]="referralReportItem.candidateName"
            (click)="$event.stopPropagation()"
          >
            {{ referralReportItem.candidateName }}
          </a>
          <mojo-candidate-resume-preview-link
            class="ml-2"
            [candidate]="candidate$ | async"
            [linkText]="''"
            [iconEnlarge]="true"
          >
          </mojo-candidate-resume-preview-link>
        </div>
      </div>

      <div class="cell col-sm-1">
        <span>{{ referralReportItem.createdDate | date: 'shortDate' }}</span>
      </div>

      <div class="cell col-sm-2">
        <div
          class="wrapper"
          [ngClass]="{'phase':
          !!referralReportItem.label, 'hired':
          !!referralReportItem.label &&
          referralReportItem.hired }"
        >
          <mat-icon
            class="mr-1"
            *ngIf="!!referralReportItem.label"
            [svgIcon]="referralReportItem.phaseIcon"
          >
          </mat-icon>
          <span>{{ referralReportItem.label }}</span>
        </div>

      </div>
    </div>
  </common-mojo-card>
</a>

<ng-template #mobile>
  <div class="row">
    <div class="cell">
      <div class="wrapper d-flex flex-column">
        <span class="bold mb-2"> {{ showBy === 'Job' ?
          this.referralReportItem.title :
          this.referralReportItem.referredBy }}
        </span>
        <div class="wrapper d-flex flex-column">
          <span class="content">Function: {{ showBy === 'Job' ?
            this.referralReportItem.jobFunctionName :
            this.referralReportItem.referralFunctionName }}
          </span>
          <span class="content">
            Dept: {{ showBy === 'Job' ?
            this.referralReportItem.jobDepartmentName :
            this.referralReportItem.referralDepartmentName }}
          </span>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="cell">
      <div class="wrapper d-flex flex-column">
        <span class="content">Referred candidate</span>
        <div class="wrapper d-flex flex-row align-items-center">
          <a
            class="highlight-link text-truncate"
            [routerLink]="['/candidates',referralReportItem?.candidateId,
            'details']"
            [matTooltip]="referralReportItem.candidateName"
            (click)="$event.stopPropagation()"
          >
            {{ referralReportItem.candidateName }}
          </a>
          <mojo-candidate-resume-preview-link
            class="ml-2"
            [candidate]="candidate$ | async"
            [linkText]="''"
            [iconEnlarge]="true"
          >
          </mojo-candidate-resume-preview-link>
        </div>
      </div>
    </div>
  </div>
</ng-template>
